module.exports = __webpack_public_path__ + "img/logo_usdc.9e04a233.png";